export default {
  Titulo: 'Emissão',
  Campos: {
    Modulo: {
      Tipo: 'combobox',
      Label: 'Módulo',
      Placeholder: ' ',
      Tamanho: 50,
      Tooltip: 'Módulo',
      Obrigatorio: false,
      itens: [],
    },
    Relatorio: {
      Tipo: 'typeahead',
      Label: 'Relatório',
      Tooltip: 'Relatório',
      Placeholder: 'Relatório',
      Obrigatorio: false,
      Desabilitado: false,
    },
    TipoBaixa: {
      Tipo: 'suggestion',
      Label: 'Tipo de Baixa',
      Placeholder: ' ',
      Tamanho: 50,
      Tooltip: 'Tipo de Baixa',
      Obrigatorio: false,
    },
    ValorInicial: {
      Tipo: 'decimal',
      Label: 'Valor Inicial',
      Placeholder: ' ',
      Tamanho: 50,
      Tooltip: 'Valor Inicial',
      Obrigatorio: false,
    },
    ValorFinal: {
      Tipo: 'decimal',
      Label: 'Valor Final',
      Placeholder: ' ',
      Tamanho: 50,
      Tooltip: 'Valor Final',
      Obrigatorio: false,
    },
    SetorOrigem: {
      Tipo: 'combobox',
      Label: 'Setor Origem',
      Placeholder: ' ',
      Tamanho: 50,
      Tooltip: 'Setor Origem',
      Obrigatorio: false,
      itens: [
        { Texto: 'Imobiliario', Valor: 'Imobiliario' },
        { Texto: 'Divida Ativa', Valor: 'Divida Ativa' },
      ],
    },
    ModalRelatorio: {
      Tipo: 'suggestion',
      Label: 'Relatório',
      Placeholder: ' ',
      Tamanho: 50,
      Tooltip: 'Relatório',
      Obrigatorio: false,
    },
    ModalExercicio: {
      Tipo: 'number',
      Label: 'Exercício',
      Placeholder: ' ',
      Tamanho: 50,
      Tooltip: 'Exercício',
      Obrigatorio: true,
    },
    ModalTipoBaixa: {
      Tipo: 'suggestion',
      Label: 'Tipo de Baixa',
      Placeholder: ' ',
      Tamanho: 50,
      Tooltip: 'Tipo de Baixa',
      Obrigatorio: false,
    },
    ModalValorInicial: {
      Tipo: 'decimal',
      Label: 'Valor Inicial',
      Placeholder: ' ',
      Tamanho: 50,
      Tooltip: 'Valor Inicial',
      Obrigatorio: false,
    },
    ModalValorFinal: {
      Tipo: 'decimal',
      Label: 'Valor Final',
      Placeholder: ' ',
      Tamanho: 50,
      Tooltip: 'Valor Final',
      Obrigatorio: false,
    },
    ModalSetorOrigem: {
      Tipo: 'combobox',
      Label: 'Setor Origem',
      Placeholder: ' ',
      Tamanho: 50,
      Tooltip: 'Setor Origem',
      Obrigatorio: false,
      itens: [
        { Texto: 'Imobiliario', Valor: 'Imobiliario' },
        { Texto: 'Divida Ativa', Valor: 'Divida Ativa' },
      ],
    },
    ProcessarSegundoPlano: {
      Tipo: 'checkbox',
      Label: ' Processar em segundo plano',
      Tooltip: 'Processar relatório em segundo plano',
    },
    Formato: {
      Tipo: 'combobox',
      Label: 'Formato',
      Placeholder: 'Formato',
      Tamanho: 50,
      Tooltip: 'Formato',
      Obrigatorio: true,
      itens: [
        { Texto: 'PDF', Valor: 'PDF' },
        { Texto: 'XLS', Valor: 'XLS' },
      ],
    },
  },
};
